import { useEffect } from 'react';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';

export const usePageTitle = (title: string) => {
  const [t] = useLocalization('Account');
  useEffect(() => {
    document.title = `${t('My Account')} - ${title}`;
  }, [t, title]);
};
